import { useKeycloak } from "@react-keycloak/web";

export const useIsAdmin = () => {
	const { keycloak, initialized } = useKeycloak();

	if (!initialized || !keycloak.authenticated) {
		return false;
	}

	return keycloak.hasRealmRole("admin");
}